<div [class]="'info-icon ' + size">
    <div class="img-container" [ngClass]="{'heart':settings.type === 'breeding', 'gender':settings.type === 'gender',
    'text':settings.type === 'text','currency':settings.type === 'currency','syntetic':settings.type === 'syntetic'}">
        <img *ngIf="imgPath" [src]="imgPath" />
        <div *ngIf="settings.label || settings.label=='0'" [class]="'label '+ settings.labelClass">
            <!-- format-number -->
            <span *ngIf="settings.type ==='currency'">
                {{_currencyValue}}
            </span>
            <span *ngIf="settings.type !=='currency'">
                {{settings.label}}
            </span>
        </div>
    </div>
</div>